export default __webpack_public_path__ + "static/png-assets-07-074673a90df7342cabfdfa2cca62f4a6.png";